module.exports = __webpack_public_path__ + "static/media/xdai.fbc2e922.jpg";